import { withStyles } from '@material-ui/core/styles';
import Loader from './Loader';
import styles from './styles';

export default withStyles(styles)(Loader);

